import {
  Grid,
  InputAdornment,
  Paper,
  TextField,
  useTheme,
} from "@material-ui/core";
import { DateTimePicker } from "@material-ui/pickers";
import { Moment } from "moment";
import React, { useEffect, useState } from "react";
import { STRESSOR_CHECK_IN_MODE, STRESSOR_CHECK_OUT_MODE } from "./constants";
import { useStressEntryContext } from "./StressEntryContext";

export const DampHeatFields = ({ UnitVersion }: any) => {
  const theme = useTheme();
  const { state, dispatch } = useStressEntryContext();

  const [formData, setFormData] = useState({
    Calibration_date: null as Moment | null,
    Test_duration: UnitVersion === "v12" ? "1000" : "",
    Test_humidity: UnitVersion === "v12" ? "85" : "",
    Test_temperature: UnitVersion === "v12" ? "85" : "",
    Weights: UnitVersion === "v12" ? "500" : "",
  });

  const handleDateChange = (date: Moment | null) => {
    setFormData((prev) => ({ ...prev, Calibration_date: date }));
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // console.log(formData)
  };

  useEffect(() => {
    if (UnitVersion === "v12") {
      setFormData((prev) => ({
        ...prev,
        Test_duration: prev.Test_duration || "1000",
        Test_humidity: prev.Test_humidity || "85",
        Test_temperature: prev.Test_temperature || "85",
        Weights: prev.Weights || "500", // don't override user input
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        Test_duration: "",
        Test_humidity: "",
        Test_temperature: "",
        Weights: "", // reset when not v12
      }));
    }
  }, [UnitVersion]);

  useEffect(() => {
    const payload = {
      Calibration_date: formData.Calibration_date
        ? formData.Calibration_date.format("YYYY-MM-DD")
        : null,
      Test_duration: formData.Test_duration
        ? parseFloat(formData.Test_duration)
        : null,
      Test_humidity: formData.Test_humidity
        ? parseFloat(formData.Test_humidity)
        : null,
      Test_temperature: formData.Test_temperature
        ? parseFloat(formData.Test_temperature)
        : null,
      weight:
        UnitVersion === "v12"
          ? formData.Weights !== "" && formData.Weights !== null
            ? parseFloat(formData.Weights)
            : 500
          : null,
    };

    dispatch({ type: "DAMPHEAT_STRESS_DETAILS", payload });
  }, [formData, dispatch, UnitVersion]);

  return (
    <div style={theme.container}>
      {state.mode === STRESSOR_CHECK_OUT_MODE && state.isDAMPHeatCheck && (
        <Paper elevation={3} style={{ padding: 16, marginBottom: 16 }}>
          <Grid
            container
            direction="row"
            justifyContent="space-around"
            alignItems="flex-start"
            spacing={2}
            style={{ marginTop: 16, marginBottom: 16 }}
          >
            <Grid item xs={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} style={{ marginTop: 18 }}>
                  <DateTimePicker
                    label="Calibration Date"
                    format="YYYY-MM-DD HH:mm"
                    fullWidth
                    value={formData.Calibration_date}
                    onChange={handleDateChange}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    name="Test_duration"
                    label="Test duration"
                    type="number"
                    value={formData.Test_duration}
                    onChange={handleChange}
                    required
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">hours</InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    name="Test_humidity"
                    label="Test Humidity"
                    type="number"
                    value={formData.Test_humidity}
                    onChange={handleChange}
                    fullWidth
                    required
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">%RH</InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {UnitVersion && UnitVersion === "v12" && (
                  <Grid item xs={12}>
                    <TextField
                      name="Weights"
                      label="Weights"
                      type="number"
                      required
                      value={formData.Weights}
                      onChange={handleChange}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">g</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                )}

                <Grid item xs={12}>
                  <TextField
                    name="Test_temperature"
                    label="Test Temperature"
                    type="number"
                    required
                    value={formData.Test_temperature}
                    onChange={handleChange}
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">°C</InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      )}
    </div>
  );
};
